const SaveIcon = () => {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21" stroke="#F87171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M9 11C11.2091 11 13 9.20914 13 7C13 4.79086 11.2091 3 9 3C6.79086 3 5 4.79086 5 7C5 9.20914 6.79086 11 9 11Z" stroke="#F87171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17 8L22 13" stroke="#F87171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M22 8L17 13" stroke="#F87171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    )
}
export default SaveIcon;